// Note: This file is used to store all the constants used in the application.
// APP_NAME removed — use `useBranding().productName` at call sites instead.
export const APP_VERSION = '1.0.0';


export const PARTITION_KEY = 'sys:smart_matrix';

// Token Refresh Threshold in Minutes
export const ACCESS_TOKEN_REFRESH_THRESHOLD_MINUTES = 10;

// Authentication Configuration
export const authConfig = {
    // Default login persistence duration in days
    // Change this value to adjust how long users stay logged in after inactivity
    // Examples: 1 = 1 day, 7 = 1 week, 30 = 1 month
    DEFAULT_LOGIN_PERSISTENCE_DAYS: 1, // Current: 1 day of inactivity
    
    // Maximum login persistence duration in days (security limit)
    MAX_LOGIN_PERSISTENCE_DAYS: 30,
    // Minimum login persistence duration in days
    MIN_LOGIN_PERSISTENCE_DAYS: 1,
    // Auto-refresh tokens when they expire within this threshold (minutes)
    TOKEN_REFRESH_THRESHOLD_MINUTES: 30,
    // Check token expiration interval (milliseconds)
    TOKEN_CHECK_INTERVAL_MS: 5 * 60 * 1000, // 5 minutes
    
    // Activity tracking - extend session when user is active
    ACTIVITY_EXTENSION_ENABLED: true, // Set to false to disable activity-based extension
    // How often to update last activity (milliseconds)
    ACTIVITY_UPDATE_INTERVAL_MS: 2 * 60 * 1000, // 2 minutes
    // Activities that count as "user activity"
    TRACKED_ACTIVITIES: ['click', 'keydown', 'scroll', 'mousemove', 'touchstart'],
    // Minimum time between activity updates (to avoid excessive storage writes)
    MIN_ACTIVITY_UPDATE_INTERVAL_MS: 30 * 1000, // 30 seconds
    
    // UI Configuration
    SHOW_PERSISTENCE_OPTIONS: false, // Set to true to show duration selection to users
};

// Local Storage Keys
export const LSK_AUTH_LOGIN_NAME = 'auth-login_name';
export const LSK_AUTH_USER_NAME = 'auth-user_name';
export const LSK_AUTH_ACCESS_TOKEN = 'auth-access_token';
export const LSK_AUTH_ACCESS_TOKEN_LIFE_IN_MINUTES = 'auth-access_token_lifeinminutes';
export const LSK_AUTH_ACCESS_TOKEN_EXPIRES = 'auth-access_token_expires';
export const LSK_AUTH_REFRESH_TOKEN = 'auth-refresh_token';
export const LSK_AUTH_REFRESH_TOKEN_LIFE_IN_MINUTES = 'auth-refresh_token_lifeinminutes';
export const LSK_AUTH_REFRESH_TOKEN_EXPIRES = 'auth-refresh_token_expires';
export const LSK_AUTH_LOGIN_TIMESTAMP = 'auth-login_timestamp';
export const LSK_AUTH_LAST_ACTIVITY_TIMESTAMP = 'auth-last_activity_timestamp';
export const LSK_AUTH_PERSISTENCE_DAYS = 'auth-persistence_days';
export const LSK_AUTH_REMEMBER_ME = 'auth-remember_me';

// Multi-Account Management Keys
export const MULTI_ACCOUNT_ACTIVE_ACCOUNT_KEY = 'smartmatrix_active_account';